function greenArrowFormsInit() {

  // Select all input elements where name attribute is 'pending_subscriber[email]'
  var inputs = document.querySelectorAll('input[name="pending_subscriber[email]"]');

  // Select the submit button
  var submitButton = document.querySelector('.button[type="submit"]');

  // Regular expression for email validation
  var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  var form = document.querySelector('form.simple_form');

  // Iterate over the inputs
  for (var i = 0; i < inputs.length; i++) {
    // Add event listener for input change
    inputs[i].addEventListener('input', function() {
      console.log('change!');
      // If the input value is not a valid email, disable the submit button
      if (!emailRegex.test(this.value)) {
        submitButton.disabled = true;
      } else {
        // If all inputs are valid emails, enable the submit button
        var allValid = Array.from(inputs).every(input => emailRegex.test(input.value));
        submitButton.disabled = !allValid;
      }
    });
  }
  
  if(!form) {
    return;
  }

  function gaFormDataToCleanedData(formElement) {
    var formData = new FormData(formElement);
    var cleanedData = {
      email: '',
      firstName: '',
      phoneNumber: ''
    };

    formData.forEach((value, key) => {
      if(!key.includes('pending_subscriber')) {
        return;
      }
      console.log(value, key);
      if(key === 'pending_subscriber[email]') {
        cleanedData.email = value;
      } else {
        const id = key.split('[')[2].split(']')[0];
        const labelElement = formElement.querySelector(`label[for="pending_subscriber_custom_fields_${id}"]`);
        const label = labelElement? labelElement.textContent : '';
        const fieldName = label.replace(/[^a-zA-Z0-9]/g, '').toLowerCase().trim();
        if (fieldName.includes('firstname')) {
          cleanedData.firstName = value;
        } else if (fieldName.includes('phone')) {
          cleanedData.phoneNumber = value;
        }
      }
    });

    return cleanedData;
  }

  form.addEventListener('submit', function (event) {
    // get closest form element
    var formElement = event.target;

    // get download URL from the form input pending_subscriber[custom_fields][17]
    var downloadURL = formElement.querySelector('input[name="pending_subscriber[custom_fields][17]"]').value;
    event.preventDefault();
    var formData = new FormData(formElement);
    var jsonData = {};
    formData.forEach((value, key) => {
      jsonData[key] = value;
    });

    gtag('event', 'email_sub_form_submit', {
      page_location: window.location.pathname,
    });

    const { email, firstName, phoneNumber } = gaFormDataToCleanedData(formElement);

    formElement.style.padding = '20px';
    formElement.innerHTML = '<p>Submitting...</p>';


    // add to Klaviyo
    (function addToKlaviyo() {
      try {
      
        if(klaviyo.identify) {
          console.log('Klaviyo identify', { email, firstName, phoneNumber });
          klaviyo.identify({
            'email' : email,
            'first_name' : firstName,
            'phone_number' : phoneNumber
          }, (err) => {
            console.log('Klaviyo identify complete', { err });
            klaviyo.track('Email subscription (free download)', {
            });
          });
        }
      } catch(err) {
        console.error(err);
      }
    })();

    fetch('https://us-central1-littleones-prod.cloudfunctions.net/httpsPublicSubscribeEmail', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        gaFormData: jsonData,
        gaFormURL: formElement.action
      })
    })
    .then(response => {
      if (response.ok) {
        // replace form with a thank you for subscribing message and download link
        var thankYouMessage = document.createElement('p');
        thankYouMessage.style.paddingBottom = '10px';
        thankYouMessage.textContent = 'Thank you for subscribing! Click the link below to download:';
        var downloadLink = document.createElement('a');
        downloadLink.href = downloadURL;
        downloadLink.classList.add('button');
        downloadLink.textContent = 'Download';
        formElement.innerHTML = '';
        formElement.appendChild(thankYouMessage);
        formElement.appendChild(downloadLink);

        console.log('Form submitted successfully');
      } else {
        console.error('Form submission failed');
      }
    })
    .catch(error => {
      console.error('Form submission failed', error);
    });

    localStorage.setItem('greenarrow_popup_closed_' + window.location.pathname, true);
  })
  
}
function greenArrowFormsFlyoutInit() {
  var flyoutElement = document.querySelector('.blog-form-flyout');
  var pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  var scrollThreshold = pageHeight * 0.5;

  window.addEventListener('scroll', function() {
    var scrollPosition = window.scrollY || window.pageYOffset;

    if (scrollPosition > scrollThreshold) {
      // Check if the popup has been closed before
      var isPopupClosed = localStorage.getItem('greenarrow_popup_closed_' + window.location.pathname);
      if (!isPopupClosed) {
        flyoutElement.classList.add('show');
      }
    }
  });

  var closeButton = document.querySelector('.flyout-close');
  closeButton && closeButton.addEventListener('click', function() {
    flyoutElement.classList.remove('show');
    // Store the flag in local storage to indicate that the popup has been closed
    localStorage.setItem('greenarrow_popup_closed_' + window.location.pathname, true);
  });
}
document.addEventListener('DOMContentLoaded', function() {
  greenArrowFormsInit();
  greenArrowFormsFlyoutInit();
});